import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

const ConfirmModal = ({
  open,
  title = "Confirm Action",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-6">

        <div className="flex justify-center mb-5">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
            <FaExclamationTriangle className="text-red-600 text-3xl" />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-center text-gray-800">
          {title}
        </h2>

        <p className="text-center text-gray-500 mt-3">
          {message}
        </p>

        <div className="flex justify-center gap-4 mt-8">

          <button
            onClick={onCancel}
            className="px-6 py-2 rounded-xl border border-gray-300 hover:bg-gray-100 transition"
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            className="px-6 py-2 rounded-xl bg-red-600 text-white hover:bg-red-700 transition"
          >
            {confirmText}
          </button>

        </div>

      </div>

    </div>
  );
};

export default ConfirmModal;    